// src/store/reducers/index.js
import { combineReducers } from 'redux';
import stationReducer from './stationReducer';

const rootReducer = combineReducers({
  station: stationReducer,
});

export default rootReducer;
